/* eslint-disable */
/**
 * Homepage Banner Notification Block Template
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders Homepgae Banner notification
 */
import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import { SVBTypography, SVBButton, SVBTextLink } from '@svb/svb-react-components';
import Loading from '@svb/api-loading-component/dist/components/index';
import { getFileContent } from '../../helpers/utilityFunctions';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';
import { useCookies } from 'react-cookie';
import error from '@svb/svbbranding/dist/assets/icons/Error.svg';


/**
 * HomepageBannerNotification
 * @param content: url of the Banner notification content
 * @returns HomepageBannerNotification
 */

const HomepageBannerNotification = ({ datatestid, testMockContent, contenturl, visible }) => {
  const [cookies, setCookie] = useCookies(['banner-notify']);
  const [loading, setLoading] = useState(true);
  // const [hidebanner, setHidebanner] = useState(true);
  const { regenTokenandBrowse } = browseAPIhandler();
  const contentURL = process.env.REACT_APP_CONTENT_SERVER || '/api-content';
  const baseProxyUrl = `${contentURL}/portal-content?resourcePath=pages`;
  const resourceContentUrl = baseProxyUrl + '&resourceName=homepage-notification-banner.md';
  const getHomepageBannerContent = datatestid
    ? testMockContent
    : getFileContent(`${resourceContentUrl}`, regenTokenandBrowse);

  useEffect(() => {
    if (getHomepageBannerContent.type === 'success') {
      setLoading(false);
    }
  }, [getHomepageBannerContent.response]);

  if (loading) {
    return <Loading />;
  }
  // Overrides BannerNotification tag from markdown and renders HomepageBannerNotificationContent
  const HomepageBannerNotificationContent = ({ type, text, children }) => {
    return (
      (visible || isEnabled) && (
        <>
          <div className='homepage-banner bannerNotifications start-0'>
            <div
              className={`bannerNotifications__container ${type ? type : 'info'} w-100 d-inline-flex align-items-center justify-content-between`}
            >
              <div className='align-items-center d-flex'>
                {type === 'error' ? (
                  <img alt='error' className='bannerNotifications__icon' src={error} />
                ) : (
                  // <img alt='exclamation' className='bannerNotifications__icon' src={infoicon} />
                  <svg
                    className='bannerNotifications__icon'
                    width='30'
                    height='30'
                    viewBox='0 0 30 30'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M15 30C6.72 30 0 23.28 0 15C0 6.72 6.72 0 15 0C23.28 0 30 6.72 30 15C30 23.28 23.28 30 15 30ZM16.5 7.5H13.5V10.5H16.5V7.5ZM16.5 13.5H13.5V22.5H16.5V13.5Z'
                      fill='currentColor'
                    />
                  </svg>
                )}
                <span className='ps-3'>{text}</span>
              </div>
              <div className='text-center'>{children}</div>
            </div>
          </div>
          {/* @todo update global banner notification to add classes and boostrapped */}
          {/* <SVBBannerNotification type={type ? type + ' d-flex' : null} rightContent={<ButtonGroup />}>
                    {children}
                </SVBBannerNotification> */}
        </>
      )
    );
  };
  // Overrides ButtonGroup tag from markdown and renders ButtonGroup which wraps the buttons
  const ButtonGroup = ({ children }) => <div className='banner-btn-group d-inline-flex gap-4 align-items-center'>{children}</div>;

  // handles the dismiss button click in banner
  const handleClick = (cookieExpiresIn) => {
    // setHidebanner(false); //have to store in localstorage
    cookieExpiresIn
      ? setCookie('banner-notify', 'closed', { maxAge: cookieExpiresIn }) //sets cookie for cookieExpiresIn time in seconds and then clears the cookie after that time making banner notification visible
      : setCookie('banner-notify', 'closed', { expires: 0 }); //clears cookie if browser session is closed and then banner notification is visible(might have to store in localstorage)
  };

  // Overrides Button tag from markdown and renders BannerButton which renders the buttons
  const BannerButton = ({ action, type, text, href, external, cookieExpiresIn }) => {
    if (action === 'dismiss') {
      return (
        // <SVBButton
        //   text={text}
        //   size='small'
        //   style={type}
        //   state='default'
        //   type='icon'
        //   icon={}
        //   onClick={() => handleClick(cookieExpiresIn)}
        // />
        <svg
          role='button'
          onClick={() => handleClick(cookieExpiresIn)}
          width='14'
          height='14'
          viewBox='0 0 14 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z'
            fill='black'
          />
        </svg>
      );
    } else {
      return (
       <SVBTextLink external={external} href={href} type="btn-primary" text={text} />
      );
    }
  };

  const bannerResponse = getHomepageBannerContent.response;
  const isVisible = bannerResponse.match(/visible\s*=\s*\{(true|false)\}/i);
  const isEnabled = isVisible ? isVisible[1] === 'true' : null;
  return (
    <>
      {cookies['banner-notify'] !== 'closed' && (
        <Markdown
          options={{
            overrides: {
              h3: {
                component: SVBTypography,
                props: {
                  type: 'heading-medium',
                  variant: 'homepage_hero__subheading',
                },
              },
              h1: {
                component: SVBTypography,
                props: {
                  type: 'heading-xlarge',
                  variant: 'homepage_hero__heading',
                },
              },
              BannerNotification: {
                component: HomepageBannerNotificationContent,
              },
              ButtonGroup: {
                component: ButtonGroup,
              },
              Button: {
                component: BannerButton,
              },
            },
          }}
        >
          {getHomepageBannerContent.response}
        </Markdown>
      )}
    </>
  );
};
export default HomepageBannerNotification;
